// src/serviceWorkerRegistration.js
// Dev: gör INGENTING. Prod: avregistrera ev. SW och rensa cache en gång.

export function register() {
  // I utveckling ska ingen service worker hanteras – annars blinkar dev-servern.
  if (process.env.NODE_ENV !== 'production') return;

  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      // Avregistrera alla SW i prod (vi vill inte cachea bygget)
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));

      // Töm alla caches
      if (window.caches && caches.keys) {
        const names = await caches.keys();
        await Promise.all(names.map(n => caches.delete(n)));
      }

      console.log('[SW] Prod: SW avregistrerad och cache rensad.');
    } catch (err) {
      console.warn('[SW] Prod: kunde inte rensa SW/caches:', err);
    }
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.ready
    .then(async (registration) => {
      try {
        await registration.unregister();
      } catch (_) {}
      if (window.caches && caches.keys) {
        const names = await caches.keys();
        await Promise.all(names.map(n => caches.delete(n)));
      }
      console.log('[SW] unregister(): SW borta, cache rensad.');
    })
    .catch((error) => {
      console.error('[SW] unregister() fel:', error?.message || error);
    });
}
